export default __webpack_public_path__ + "93129cd.png";